import React from 'react';
import ResourceList from './ResourceList';

const ResourcesPage = () => <ResourceList />;

export default ResourcesPage;
